export default __webpack_public_path__ + "static/media/users-selected.38ca2835.svg";